// extracted by mini-css-extract-plugin
export var description = "styles-module--description--opUMt";
export var spinnerPage = "styles-module--spinner-page--P34tp";
export var title = "styles-module--title--3Vo6g";